<h1 mat-dialog-title>{{ 'Move File to Folder' | transloco }}</h1>
<div mat-dialog-content>
  <mat-form-field appearance="fill" class="w-full">
    <mat-label>{{ 'List of folders' | transloco }}</mat-label>
    <mat-select [(ngModel)]="category_id">
      <mat-option *ngFor="let category of data.categories" [value]="category">
        {{ category.category_name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions class="flx-row justify-end">
  <button mat-button (click)="onNoClick()">{{ 'Cancel' | transloco }}</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="category_id" cdkFocusInitial>
    {{ 'Move' | transloco }}
  </button>
</div>
